import { Component } from '@angular/core';

@Component({
  selector: 'app-shipping-carriers-home',
  standalone: false,
  templateUrl: './shipping-carriers-home.component.html',
  styleUrl: './shipping-carriers-home.component.css',
})
export class ShippingCarriersHomeComponent {
  activeTab: 'carriers' | 'mappings' = 'carriers';

  setActiveTab(tab: 'carriers' | 'mappings'): void {
    this.activeTab = tab;
  }
}
